import { createContext } from "react";
export const I18nContext = createContext(null);
export const I18nContextProvider = I18nContext.Provider;
